import { BaseEdge, type EdgeProps, getStraightPath } from '@xyflow/react'

export function SimpleFlowEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  viewOnly,
}: EdgeProps & {
  viewOnly?: boolean
}) {
  const [edgePath] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  })

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{
        strokeWidth: 2,
        stroke: viewOnly ? 'var(--content-primary-disabled)' : 'var(--light-blue-60)',
      }}
    />
  )
}
